<app-fnf-base-dialog
  [visible]="visible()"
  class="w-[clamp(269px,80vw,402px)] min-h-[clamp(316px,80vw,418px)] items-center justify-center gap-2"
  (onClose)="close()"
>
  <div class="fnf-dialog-checkicon">
    <svg viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="64" cy="64" r="64" fill="#131C35" />
      <circle cx="64" cy="64" r="54.5" stroke="white" stroke-width="3" />
      <path
        d="M91.3553 47.7005L56.1569 82.3646C55.9526 82.566 55.7099 82.7258 55.4429 82.8349C55.1758 82.9439 54.8895 83 54.6004 83C54.3113 83 54.0251 82.9439 53.758 82.8349C53.4909 82.7258 53.2483 82.566 53.044 82.3646L37.6447 67.1991C37.2319 66.7925 37 66.2412 37 65.6663C37 65.0913 37.2319 64.54 37.6447 64.1335C38.0575 63.7269 38.6174 63.4985 39.2011 63.4985C39.7849 63.4985 40.3448 63.7269 40.7576 64.1335L54.6004 77.7689L88.2424 44.6349C88.6552 44.2284 89.2151 44 89.7989 44C90.3826 44 90.9425 44.2284 91.3553 44.6349C91.7681 45.0414 92 45.5928 92 46.1677C92 46.7426 91.7681 47.294 91.3553 47.7005Z"
        fill="white"
      />
    </svg>
  </div>

  <!-- Título -->
  <h2 class="fnf-dialog-title text-center" [innerHTML]="getFormattedText('title')"></h2>

  <!-- Descripción opcional -->
  @if (dialogProps().description) {
  <p class="fnf-dialog-subtitle text-center" [innerHTML]="getFormattedText('description')"></p>
  }

  <app-fnf-buttons [buttonProps]="{ text: dialogProps().buttonText }" (onClick)="close()" />
</app-fnf-base-dialog>
